if (!Shopify.designMode) {
  (function() {
    document.querySelectorAll('.co-learn-2-pinned').forEach((slide, i) => {
      const isTall = slide.offsetHeight > window.innerHeight;
      const start = isTall ? "bottom bottom" : "top top";
      ScrollTrigger.create({
        trigger: slide,
        start: start,
        end: () => `+=${slide.offsetHeight}`,
        pin: true,
        pinSpacing: false
      });
      gsap.to(slide.querySelectorAll('.co-learn-2-scale'), {
        opacity: 0,
        scale: 0.7,
        scrollTrigger: {
          trigger: slide,
          start: start,
          end: () => `+=${slide.offsetHeight * 1}`,
          scrub: 1.25
        }
      });
    });
  })();
}
// ======================================================================================================================= SECTION 3
(function() {
  const CONFIG = {
    pause: 2000,
    animationSpeed: 500,
    autoWidth: false
  };

  class WordSwitcher {
    constructor(element) {
      this.container = element;
      this.words = Array.from(element.querySelectorAll('.co-learn-3-block-1-word-switcher__word'));
      this.wordCount = this.words.length;
      this.currentIndex = 0;
      this.resizeTimeout = null;

      if (this.wordCount > 1) {
        this.init();
      }
    }

    init() {
      this.container.style.setProperty('--word-switcher-animation-speed', `${CONFIG.animationSpeed}ms`);
      this.autoWidth = this.container.dataset.wordSwitcherAutoWidth !== undefined
        ? this.container.dataset.wordSwitcherAutoWidth !== 'false'
        : CONFIG.autoWidth;

      if (this.autoWidth) {
        this.setContainerWidth();
      }

      this.words[0].classList.add('is-active');
      this.startLoop();

      if (this.autoWidth) {
        this.bindResize();
      }
    }

    bindResize() {
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.setContainerWidth(), 100);
      });
    }

    setContainerWidth() {
      const containerEl = this.container.querySelector('.co-learn-3-block-1-word-switcher__container');
      let maxWidth = 0;

      this.words.forEach(word => {
        word.style.transition = 'none';
        word.style.transform = 'translateY(0)';
        word.style.position = 'relative';
        word.style.visibility = 'hidden';

        word.offsetHeight;
        const width = word.offsetWidth;
        if (width > maxWidth) maxWidth = width;

        word.style.transform = '';
        word.style.position = '';
        word.style.visibility = '';
        word.offsetHeight;
        word.style.transition = '';
      });

      containerEl.style.width = `${maxWidth}px`;
    }

    startLoop() {
      setInterval(() => this.next(), CONFIG.pause);
    }

    next() {
      const currentWord = this.words[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.wordCount;
      const nextWord = this.words[nextIndex];

      currentWord.classList.remove('is-active');
      currentWord.classList.add('is-exiting');
      nextWord.classList.add('is-active');

      setTimeout(() => {
        currentWord.style.transition = 'none';
        currentWord.classList.remove('is-exiting');
        currentWord.offsetHeight;
        currentWord.style.transition = '';
      }, CONFIG.animationSpeed);

      this.currentIndex = nextIndex;
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-word-switcher]').forEach(function(el) {
      new WordSwitcher(el);
    });
  });
})();
// ======================================================================================================================= SECTION 3 PIN
if (!Shopify.designMode) {
  (function() {
    document.querySelectorAll('.co-learn-3-pin').forEach((slide, i) => {
      const isTall = slide.offsetHeight > window.innerHeight;
      const start = isTall ? "bottom bottom" : "top top";
      ScrollTrigger.create({
        trigger: slide,
        start: start,
        end: () => `+=${slide.offsetHeight}`,
        pin: true,
        pinSpacing: false
      });
      gsap.to(slide.querySelectorAll('.co-learn-3-scale'), {
        opacity: 0,
        scale: 0.7,
        scrollTrigger: {
          trigger: slide,
          start: start,
          end: () => `+=${slide.offsetHeight * 1}`,
          scrub: 1.25
        }
      });
    });
  })();
}
// ======================================================================================================================= SECTION 5 PIN
if (!Shopify.designMode) {
  (function() {
    ScrollTrigger.create({
      trigger: '.co-learn-5-comp-pin',
      endTrigger: '.co-learn-5-comp-2',
      start: 'top top',
      end: 'top top',
      pin: true,
      pinSpacing: false
    });
    ScrollTrigger.create({
      trigger: '.co-learn-5-comp-pin',
      endTrigger: '.co-learn-5-comp-2',
      start: 'top top',
      end: 'top top',
      pin: '.co-learn-5-mantra',
      pinSpacing: false
    });
  })();
}
// HEIGHT MATCH
(() => {
  const els = document.querySelectorAll('.co-learn-5-comp-bottom-bg');
  if (els.length < 2) return;

  const sync = () => {
    els.forEach(el => el.style.height = '');
    const max = Math.max(...[...els].map(el => el.offsetHeight));
    els.forEach(el => el.style.height = `${max}px`);
  };

  sync();
  new ResizeObserver(sync).observe(els[0].parentElement);
})();

(function() {
  'use strict';

  const config = {
    sourceSelector: '[data-height-source]',
    targetSelector: '[data-height-target]',
    cssVariable: '--co-dynamic-height',
    debounceDelay: 150
  };

  let resizeTimeout = null;
  let resizeObserver = null;

  function updateHeight() {
    const source = document.querySelector(config.sourceSelector);
    const target = document.querySelector(config.targetSelector);

    if (!source || !target) return;

    const height = source.offsetHeight;
    target.style.setProperty(config.cssVariable, `${height}px`);
  }

  function debouncedUpdate() {
    if (resizeTimeout) {
      cancelAnimationFrame(resizeTimeout);
    }
    resizeTimeout = requestAnimationFrame(updateHeight);
  }

  function init() {
    updateHeight();

    const source = document.querySelector(config.sourceSelector);
    if (source && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(debouncedUpdate);
      resizeObserver.observe(source);
    }

    window.addEventListener('resize', debouncedUpdate, { passive: true });
  }

  function destroy() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    window.removeEventListener('resize', debouncedUpdate);
    if (resizeTimeout) {
      cancelAnimationFrame(resizeTimeout);
      resizeTimeout = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.DynamicHeight = {
    update: updateHeight,
    destroy: destroy,
    init: init
  };
})();
